// Built once per immutable catalog, reused for every weight/cart preview.
export const buildCatalogVarietyIndex = (products = []) => {
  const index = new Map();
  products.forEach(product => (product.Varieties || []).forEach(variety => {
    const id = Number(variety.id);
    if (!index.has(id)) index.set(id, { product, variety });
  }));
  return index;
};
